import { act_com } from '@lc/action/cardType/Common';
import { createCardEquipmentVerbose } from '@lc/interface/card/equipment/factory';
import { Equipment } from '@lc/interface/card/equipment/types';
import { GameState } from '@lc/interface/gameState/types';

export const getEquipmentVerbose = (EquipmentMeta: Equipment[]) => [
	createCardEquipmentVerbose(
		// 133 selfImageSacrifice
		EquipmentMeta[0],
		(playerData: any, gameState: GameState) =>
			act_com.notPlayable(playerData, gameState),
		(playerData: any, gameState: GameState) =>
			act_com.notPlayable(playerData, gameState),
		(playerData: any, gameState: GameState) =>
			act_com.selfImageSacrifice(playerData, gameState)
	),
	createCardEquipmentVerbose(
		// 134 selfImageSacrifice
		EquipmentMeta[1],
		(playerData: any, gameState: GameState) =>
			act_com.notPlayable(playerData, gameState),
		(playerData: any, gameState: GameState) =>
			act_com.notPlayable(playerData, gameState),
		(playerData: any, gameState: GameState) =>
			act_com.selfImageSacrifice(playerData, gameState)
	),
	createCardEquipmentVerbose(
		// 135 tieBreaker
		EquipmentMeta[2],
		(playerData: any, gameState: GameState) =>
			act_com.tieBreakerAddModifier(playerData, gameState),
		(playerData: any, gameState: GameState) =>
			act_com.notPlayable(playerData, gameState),
		(playerData: any, gameState: GameState) =>
			act_com.notPlayable(playerData, gameState)
	),
	createCardEquipmentVerbose(
		// 136 FARM OF ANIMALS
		EquipmentMeta[3],
		(playerData: any, gameState: GameState) =>
			act_com.notPlayable(playerData, gameState),
		(playerData: any, gameState: GameState) =>
			act_com.notPlayable(playerData, gameState),
		(playerData: any, gameState: GameState) =>
			act_com.notPlayable(playerData, gameState)
	),
	createCardEquipmentVerbose(
		// 137 CHURCH OF PSEUDOSCIENCE
		EquipmentMeta[4],
		(playerData: any, gameState: GameState) =>
			act_com.notPlayable(playerData, gameState),
		(playerData: any, gameState: GameState) =>
			act_com.notPlayable(playerData, gameState),
		(playerData: any, gameState: GameState) =>
			act_com.pseudoscience(playerData, gameState)
	),
	createCardEquipmentVerbose(
		// 138 RECYCLING PLANT
		EquipmentMeta[5],
		(playerData: any, gameState: GameState) =>
			act_com.notPlayable(playerData, gameState),
		(playerData: any, gameState: GameState) =>
			act_com.notPlayable(playerData, gameState),
		(playerData: any, gameState: GameState) =>
			act_com.recyclingPlant(playerData, gameState)
	),
	createCardEquipmentVerbose(
		// 139 ENERGY LEECH
		EquipmentMeta[6],
		(playerData: any, gameState: GameState) =>
			act_com.notPlayable(playerData, gameState),
		(playerData: any, gameState: GameState) =>
			act_com.notPlayable(playerData, gameState),
		(playerData: any, gameState: GameState) =>
			act_com.notPlayable(playerData, gameState)
	),
	createCardEquipmentVerbose(
		// 140 ENERGY LEECH
		EquipmentMeta[7],
		(playerData: any, gameState: GameState) =>
			act_com.notPlayable(playerData, gameState),
		(playerData: any, gameState: GameState) =>
			act_com.notPlayable(playerData, gameState),
		(playerData: any, gameState: GameState) =>
			act_com.notPlayable(playerData, gameState)
	),
	createCardEquipmentVerbose(
		// 141 MULLIGAN
		EquipmentMeta[8],
		(playerData: any, gameState: GameState) =>
			act_com.notPlayable(playerData, gameState),
		(playerData: any, gameState: GameState) =>
			act_com.notPlayable(playerData, gameState),
		(playerData: any, gameState: GameState) =>
			act_com.mulligan(playerData, gameState)
	),
	createCardEquipmentVerbose(
		// 142 FAKE NEWS
		EquipmentMeta[9],
		(playerData: any, gameState: GameState) =>
			act_com.notPlayable(playerData, gameState),
		(playerData: any, gameState: GameState) =>
			act_com.notPlayable(playerData, gameState),
		(playerData: any, gameState: GameState) =>
			act_com.notPlayable(playerData, gameState)
	),
	createCardEquipmentVerbose(
		// 143 ALTERNATIVE FACTS
		EquipmentMeta[10],
		(playerData: any, gameState: GameState) =>
			act_com.notPlayable(playerData, gameState),
		(playerData: any, gameState: GameState) =>
			act_com.notPlayable(playerData, gameState),
		(playerData: any, gameState: GameState) =>
			act_com.notPlayable(playerData, gameState)
	),
];
